import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { SourceCategory } from '@referrals/shared/models';

@Injectable({
  providedIn: 'root',
})
export class SourceCategoryService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/sourcecategories`;
  }

  public get(): Observable<SourceCategory[]> {
    return this.http.get<SourceCategory[]>(this.accessPointUrl, {
      headers: this.headers,
    });
  }

  public getById(id: number): Observable<SourceCategory[]> {
    return this.http.get<SourceCategory[]>(this.accessPointUrl + '/' + id, {
      headers: this.headers,
    });
  }

  public add(payload): Observable<SourceCategory> {
    return this.http.post<SourceCategory>(this.accessPointUrl, payload, {
      headers: this.headers,
    });
  }

  public update(payload): Observable<SourceCategory> {
    return this.http.put<SourceCategory>(
      this.accessPointUrl + '/' + payload.id,
      payload,
      {
        headers: this.headers,
      }
    );
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(this.accessPointUrl + '/' + id, {
      headers: this.headers,
    });
  }
}
